import React from 'react'
import TopBar from '../../Home/Mainhomeone/Topbar'
import Header from '../../Globle/Header1'
import Navigation from '../../Home/Mainhomeone/Navigation'
import Bredcrumb from '../../Globle/Breadecrumb'
import About from '../Mainaboutus/About'
import Justice from '../Mainaboutus/Justice'
import Dream from '../Mainaboutus/Dream'
import Footer1 from '../../Globle/Footer1'

const Main = () => {
    return (
        <>
            <TopBar />
            <Header />
            <Navigation />
            <Bredcrumb title='Aboutus' />
            <About />
            <Justice />
            <Dream />
            <Footer1 />
        </>
    )
}

export default Main
